import './modules/polyfills';
import accessibleToggle from './modules/accessible-toggle';
import { embedVideo } from './modules/embed-video';
import { yall } from './vendor/yall-v3.1.6';

export const app = () => {
  var videos = document.querySelectorAll('.js-embed-video');

  if (videos) {
    embedVideo().init(videos);
  }

  document.addEventListener('click', function(e) {
    if (e.target && e.target.id === 'js-accordion-header') {
      var accordions = document.querySelectorAll('.js-accordion');
      if (accordions.length) {
        accordions[0].classList.toggle('accordion__hide');
      }
    }
  });

  var navigation = document.getElementById('cf-nav');
  if (navigation) {
    var toggle = new accessibleToggle(navigation, {
      closeOnEsc: true,
      closeOnClickOutside: true,
      trapFocus: true,
      onShow: function(event) {
        document.querySelector('body').classList.add('overflow-hidden');
      },
      onHide: function(event) {
        document.querySelector('body').classList.remove('overflow-hidden');
      },
    });
  }

  var machineSettingsButtons = document.querySelectorAll('.js-machinesettings');
  if (machineSettingsButtons.length) {
    for (var i = 0; i < machineSettingsButtons.length; i++) {
      var machineToggle = new accessibleToggle(machineSettingsButtons[i], {
        closeOnEsc: false,
        closeOnClickOutside: false,
        trapFocus: true,
      });
    }
  }

  yall({
    events: {
      load: function(event) {
        const element = event.target;

        if (!element.classList.contains('lazy') && element.nodeName == 'IMG') {
          element.classList.add('lazy--loaded');
        }
      },
    },
    observeChanges: true,
  });
};

document.readyState !== 'loading'
  ? app()
  : document.addEventListener('DOMContentLoaded', app);
